(() => {
  if (window.__wittenwaldCartRecommendationImageFixV523) return;
  window.__wittenwaldCartRecommendationImageFixV523 = true;

  const updateRecommendationImage = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const select = target.closest('[data-cart-recommendation-select]');
    if (!select) return;

    const card = select.closest('[data-cart-recommendation-card]');
    const option = select.options?.[select.selectedIndex];
    const image = card?.querySelector('[data-cart-recommendation-image]');
    const imageUrl = option?.dataset?.image;

    if (!image || !imageUrl) return;

    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = imageUrl;
    image.setAttribute('src', imageUrl);
  };

  document.addEventListener('change', updateRecommendationImage, true);
  document.addEventListener('input', updateRecommendationImage, true);
})();
